// extracted by mini-css-extract-plugin
export default {"wrapper":"error-message-module--wrapper--NNmWL"};